<!-- R8: raw close markup -> the shared app-dialog-close-button (20px glyph). -->
<app-dialog-close-button
  *ngIf="data.showClose"
  class="confirm-dialog__close"
  (closed)="close(false)"
></app-dialog-close-button>

<div class="confirm-dialog">
  <!-- P4: the `danger` flavor renders no icon — the crimson trash glyph clashed
       with the orange destructive action button. Only the neutral info circle
       is drawn. -->
  <span *ngIf="variant !== 'danger'" class="confirm-dialog__icon">
    <vng-icon [name]="icon" color="accent" [size]="32"></vng-icon>
  </span>

  <h2 class="confirm-dialog__title" vng-dialog-title [innerHTML]="data.title"></h2>
  <p *ngIf="data.message" class="confirm-dialog__message" [innerHTML]="data.message"></p>

  <vng-dialog-actions class="confirm-dialog__actions">
    <!-- P1: `outline`, not `secondary` — secondary paints a near-black border
         that master never had, and every other dismiss button in the app now
         uses the light outline treatment. -->
    <button type="button" vng-button variant="outline" tabindex="2" (click)="close(false)">
      {{ cancelLabel }}
    </button>
    <button type="button" vng-button variant="primary" tabindex="-1" (click)="close(true)">
      {{ confirmLabel }}
    </button>
  </vng-dialog-actions>
</div>
